import { connectRouter } from 'connected-react-router/immutable';
import { combineReducers } from 'redux';

import { externalReducer } from '../app/external/ExternalReducer';
import SnackbarReducer from '../app/snackbar/SnackbarReducer';
import AnnotatorReducer from '../modules/annotator/AnnotatorReducer';
import LoginReducer from '../modules/login/LoginReducer';
import UploaderReducer from '../modules/uploader/UploaderReducer';

export default function createRootReducer(history: any) {
  return combineReducers({
    annotator: AnnotatorReducer,
    login: LoginReducer,
    router: connectRouter(history),
    snackbar: SnackbarReducer,
    uploader: UploaderReducer,
    external: externalReducer,
  });
}

export const resetEnhancer = (rootReducer: any) => (state: any, action: any) =>
  rootReducer(state, action);
